/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Layout
//   Details:    Layout
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101885 26/06/19 AJ  M01  Added Links
// 104759 21/11/19 JC  M02  Whole menu now soft-coded
// 106380 30/04/20 JC  M03  Added authentication
// 110638 28/01/21 JC       Bootstrap upgrade
//-------------------------------------------------------
*/
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import NavMenu from './NavMenu';
import PrintView from './PrintView';
import AlertPanel from '../components/AlertPanel';

import useMediaQuery from '@material-ui/core/useMediaQuery';

const Layout = (props) => {
  const [needsSmallMenu, setNeedsSmallMenu] = React.useState(false);

  const smallScreenSizeQuery = "(max-width:767px)";

  const mediaQueryNeedsSmallMenu = useMediaQuery(smallScreenSizeQuery);

useEffect(() => {
  if (needsSmallMenu !== mediaQueryNeedsSmallMenu) {
    //handleDrawerClose();
    //handleProfileMenuClose();
  }
  setNeedsSmallMenu(mediaQueryNeedsSmallMenu);
}, [mediaQueryNeedsSmallMenu]);

const renderPrintView = () => {
  return (
    <PrintView item={props.printViewItem} closeView={props.closeView} />
  );
};

const renderNavMenu = () => {
  return (
    /*M01 M02 M03*/ 
    < NavMenu
      systemControl={props.systemControl}
      authentication={props.authentication}
      needsSmallMenu={needsSmallMenu || !props.isNavbarVisible}
    />  
  );
};

const renderComponents = () => {
  return (
    <>
      {props.alerts.map((alert, index) =>
        <AlertPanel key={index} type="danger" message={alert.message} clear={props.clear} />
      )}
      {props.children}
    </>
  );
};

const renderSmallMenuLayout = () => {
  return (
    <Row>
      {/* if the navbar's visible then render a menu */
        props.isNavbarVisible ?
          renderNavMenu()
          : []}
      <Col sm={12} className="content-container">
        {renderComponents()}
      </Col>
    </Row>
  );
};

const renderLargeMenuLayout = () => {
  return (
    <Row>
      <Col sm={3}>
        {renderNavMenu()}
      </Col>
      <Col sm={9} className="content-container">
        {renderComponents()}
      </Col>
    </Row>
  );
};

const renderLayout = () => {
  return (
    <Container fluid>
      {
        /* if we need a small menu, or the navbar's not visible then render a small menu layout */
        needsSmallMenu || !props.isNavbarVisible ? renderSmallMenuLayout() : renderLargeMenuLayout()
      }
    </Container>
  );
};

return (
  <>
    {
      props.printViewItem ? renderPrintView() : renderLayout()
    }
  </>
);

};

Layout.propTypes = {
	printViewItem: PropTypes.any,
	alerts: PropTypes.arrayOf(PropTypes.any),
	children: PropTypes.any,
	clear: PropTypes.func.isRequired,
    closeView: PropTypes.func.isRequired,
    //M02 just pass down the whole of system control
    //companyName: PropTypes.string.isRequired,
    //link1Title: PropTypes.string.isRequired,  //M01
    //link1URL: PropTypes.string.isRequired,  //M01
    //link2Title: PropTypes.string.isRequired,  //M01
    //link2URL: PropTypes.string.isRequired  //M01
    systemControl: PropTypes.object.isRequired, //M02
    authentication: PropTypes.object.isRequired //M03
};

export default Layout;